/**
 *  Check if a record (an object) is empty (it doesn't contain any keys).
 */
export function isRecordEmpty(value) {
    return Object.keys(value).length === 0;
}
